import React from 'react';

function PrivacyPolicy() {
  return (
    <div className="w-full p-6">
      <h1 className="text-2xl font-bold mb-4">Privacy Policy</h1>
      <p className="mb-4 text-sm text-gray-700 dark:text-gray-300">Last updated: November 30, 2025</p>

      <section className="mb-4">
        <h2 className="font-semibold">1. Introduction</h2>
        <p className="text-sm text-gray-700 dark:text-gray-300">We respect your privacy. This Privacy Policy explains how we collect, use, disclose, and protect your personal information when you use our Service.</p>
      </section>

      <section className="mb-4">
        <h2 className="font-semibold">2. Information We Collect</h2>
        <p className="text-sm text-gray-700 dark:text-gray-300">We may collect information you provide directly (for example, your username, profile settings, and chat messages) and technical information automatically (such as IP address, device type, and browser). We do not collect payment information since the Service does not process payments directly.</p>
      </section>

      <section className="mb-4">
        <h2 className="font-semibold">3. How We Use Your Information</h2>
        <p className="text-sm text-gray-700 dark:text-gray-300">We use the information to provide and improve the Service, maintain and secure our systems, personalize user experience, and to communicate with you (such as service messages or updates).</p>
      </section>

      <section className="mb-4">
        <h2 className="font-semibold">4. Cookies and Tracking</h2>
        <p className="text-sm text-gray-700 dark:text-gray-300">We may use cookies and similar technologies to store preferences and track usage patterns. We do not send personal identifiers to third-party analytics by default. If analytics are enabled, they are used only for aggregate, non-identifying metrics.</p>
      </section>

      <section className="mb-4">
        <h2 className="font-semibold">5. Third-Party Services</h2>
        <p className="text-sm text-gray-700 dark:text-gray-300">We may use third-party services (for hosting, analytics, and other functionality). These providers may process data on our behalf; their use of your data is governed by their privacy policies.</p>
      </section>

      <section className="mb-4">
        <h2 className="font-semibold">6. Sharing and Disclosure</h2>
        <p className="text-sm text-gray-700 dark:text-gray-300">We do not sell your personal information. We may disclose information if required by law or to protect our rights, or to provide the Service (for example, to hosting or analytics providers).</p>
      </section>

      <section className="mb-4">
        <h2 className="font-semibold">7. Data Retention and Security</h2>
        <p className="text-sm text-gray-700 dark:text-gray-300">We retain personal data for as long as necessary to provide the Service and for legitimate business purposes. We implement reasonable security measures to protect your information, but no system is completely secure.</p>
      </section>

      <section className="mb-4">
        <h2 className="font-semibold">8. Your Rights</h2>
        <p className="text-sm text-gray-700 dark:text-gray-300">Depending on your jurisdiction, you may have rights to access, correct, or delete your personal data. To exercise these rights, contact us using the information below.</p>
      </section>

      <section className="mb-4">
        <h2 className="font-semibold">9. Children</h2>
        <p className="text-sm text-gray-700 dark:text-gray-300">The Service is not intended for children under the minimum age required in their jurisdiction. We do not knowingly collect personal information from children under that age.</p>
      </section>

      <section className="mb-4">
        <h2 className="font-semibold">10. Changes to This Policy</h2>
        <p className="text-sm text-gray-700 dark:text-gray-300">We may update this Privacy Policy occasionally. We will post the updated policy on this page with a revised 'Last updated' date.</p>
      </section>

      <section className="mb-6">
        <h2 className="font-semibold">11. Contact</h2>
        <p className="text-sm text-gray-700 dark:text-gray-300">If you have questions or requests about your privacy, contact us via the project's repository or the contact information provided in the app.</p>
      </section>

      <div className="text-sm text-gray-600">&copy; {new Date().getFullYear()} Game for a Laugh. All rights reserved.</div>
    </div>
  );
}

export default PrivacyPolicy;
